import { Component, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

/**
 * Handels the customer details 
 * with angular forms
 */

@Component({
  selector: 'customer-form',
  templateUrl: 'customer-form.html'
})
export class CustomerFormComponent {
  @Output() customerData: EventEmitter<any> = new EventEmitter();
  text: string;
  customerForm: FormGroup;

  constructor() {
    this.customerForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      houseName:new FormControl('', [Validators.required]),
      pinCode:new FormControl('', [Validators.required]),
      district:new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      brand: new FormControl('', [Validators.required]),
      modelName: new FormControl('', [Validators.required]),
      odo: new FormControl('', [Validators.required]),
      fuel: new FormControl('', [Validators.required]),
      year: new FormControl('', [Validators.required]),
      engineDisplacement: new FormControl(0, [Validators.required]),
      engineRpm: new FormControl(0, [Validators.required]),
      regNo: new FormControl('', [Validators.required]),
    })
  }

  // proceed with the form
  proceed(customerData) {
    this.customerData.emit(customerData);
  }

  // rest the form 
  reset() {
    this.customerForm.reset();
  }
}



// WEBPACK FOOTER //
// ./src/components/customer-form/customer-form.ts